var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',_vm._b({attrs:{"width":_vm.width,"visible":_vm.visible,"destroy-on-close":""},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true},{key:"footer",fn:function(){return [_vm._t("footer")]},proxy:true}],null,true)},'el-dialog',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }